import { ToggleButton, ToggleButtonGroup } from "@mui/material";
import classes from "../ToggleButtons.module.css";
import permission from "../PermissionUserTypesButtons.module.css";
import CustomIcon from "../../../CustomIcons/CustomIcon";
import Icons from "../../../../../resources/icons/Icons";
import { ROLES_NAMES } from "../../../../../enums/Enums";

const UserTypesButtons = (props) => {
  var classesObj = props.fromPermission ? permission : classes
  return (
    <div className={classesObj.customToggleButtons}>
      <ToggleButtonGroup
        color="primary"
        value={props.selectedValue}
        exclusive
        onChange={props.handleChange}
        className={classesObj.group}
      >
        {props.buttonsList.filter((button) => (button.name !== ROLES_NAMES.CUSTOMER) && (button.name !== ROLES_NAMES.CHARGE_ACCOUNT) && (!props.isEditMode ? button.name !== ROLES_NAMES.INACTIVE : true))
          .map((button) => {
            return (
              <ToggleButton
                key={button.id}
                className={`${classesObj.userType} ${
                  props.selectedValue === button.id ? classesObj.selected : ""
                }`}
                value={button.id}
              >
                {props.selectedValue !== button.id && (
                  <CustomIcon img={Icons.USER_TYPE} />
                )}
                {props.selectedValue === button.id && (
                  <CustomIcon img={Icons.SELECTED_USER_TYPE} />
                )}
                {button.name}
              </ToggleButton>
            );
          })}
      </ToggleButtonGroup>
    </div>
  );
};

export default UserTypesButtons;
